import { useBnplBanner } from 'hooks/bnpl/useBnplBanner';

import { BuyNowPayLaterBanner } from 'routes/home/components/BuyNowPayLaterBanner/BuyNowPayLaterBanner';

import { PlayfulFooter } from './PlayfulFooter';
import { PlayfulHeader } from './PlayfulHeader';

import s from './PlayfulLayout.module.css';

type PlayfulLayoutProps = {
  children: React.ReactNode;
};

export const PlayfulLayout = ({ children }: PlayfulLayoutProps) => {
  const {
    elementRef,
    showBanner,
    bannerContainerStyle,
    onDismissBanner,
    isDismissed,
    bnplCapabilities,
    isLoading,
  } = useBnplBanner();

  return (
    <div className={s.playful} style={bannerContainerStyle}>
      {showBanner && (
        <BuyNowPayLaterBanner
          ref={elementRef}
          onDismissBanner={onDismissBanner}
          isDismissed={isDismissed}
          capabilities={bnplCapabilities}
          isLoading={isLoading}
        />
      )}
      <div className={s.container}>
        <PlayfulHeader />
        {children}
      </div>
      <PlayfulFooter />
    </div>
  );
};
